import React from 'react';
import { Typography, Grid, useMediaQuery, Box, Button } from "@mui/material";

const News = ({ bgColor }) => {
    const isMobile = useMediaQuery('(max-width:600px)');

    return (
        <Box sx={{ backgroundColor: bgColor, py: { xs: 6, md: 10 } }}>
            <Typography 
                variant="h3"
                align="center"
                sx={{ 
                    fontWeight: 700,
                    fontSize: isMobile ? '26px' : '34px',
                    mb: 2,
                    color: 'text.primary'
                }}
            >
                Новости и достижения
            </Typography>

            <Typography 
                align="center"
                sx={{ 
                    fontSize: isMobile ? '15px' : '18px',
                    color: 'text.secondary',
                    maxWidth: '700px',
                    margin: '0 auto',
                    mb: 4
                }}
            >
                Мы регулярно делимся успехами наших учеников, результатами соревнований и жизнью центра
            </Typography>

            <Grid 
                container 
                sx={{ 
                    maxWidth: '1100px',
                    margin: '0 auto',
                    width: '100%',
                    px: { xs: 2, md: 2 },
                    gap: { xs: 2, md: 4 }, // Используем gap вместо spacing
                    justifyContent: 'center'
                }}
            >
                {/* Карточка 1 */}
                <Grid item xs={12} md={5} sx={{ padding: 0 }}> {/* Убираем padding у item */}
                    <Box sx={{
                        backgroundColor: '#ffffff',
                        borderRadius: 3,
                        p: { xs: 2, sm: 2.5 },
                        boxShadow: 2,
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        <Typography sx={{ fontWeight: 600, mb: 0.5, fontSize: { xs: '16px', sm: '18px' } }}>
                            Истории успеха учеников
                        </Typography>

                        <Typography sx={{ color: 'text.secondary', fontSize: { xs: '13px', sm: '14px' }, mb: 2 }}>
                            Победы на олимпиадах, конкурсах и реальные результаты обучения наших учеников
                        </Typography>

                        <Button 
                            variant="contained" 
                            href="https://info.cpc.tomsk.ru/news"
                            fullWidth={isMobile}
                            sx={{ 
                                alignSelf: 'flex-start',
                                fontSize: { xs: '12px', sm: '14px' }
                            }}
                        >
                            Смотреть истории
                        </Button>
                    </Box>
                </Grid>

                {/* Карточка 2 */}
                <Grid item xs={12} md={5} sx={{ padding: 0 }}> {/* Убираем padding у item */}
                    <Box sx={{
                        backgroundColor: '#ffffff',
                        borderRadius: 3,
                        p: { xs: 2, sm: 2.5 },
                        boxShadow: 2,
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        <Typography sx={{ fontWeight: 600, mb: 0.5, fontSize: { xs: '16px', sm: '18px' } }}>
                            Жизнь центра
                        </Typography>

                        <Typography sx={{ color: 'text.secondary', fontSize: { xs: '13px', sm: '14px' }, mb: 2 }}>
                            Фото, видео занятий, мероприятия и актуальные новости публикуем в социальных сетях
                        </Typography>

                        <Button 
                            variant="outlined" 
                            href="https://vk.com/cpc.tomsk"
                            fullWidth={isMobile}
                            sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                        >
                            Перейти в ВКонтакте
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default News;